import React from "react";
import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { getUserId } from "../../utilities/localStorage";

const componseResponse = (res) => {
  const data = res?.data?.data;

  return {
    providerRoom: {
      requestsFromMd: data?.provider_room.requests_from_md || 0,
    },
    mdRoom: {
      requestsReturnedByProvider:
        data?.md_room?.requests_returned_by_provider || 0,
      newPendingProcedures: {
        cosmetic: data?.md_room?.new_pending_procedures?.cosmetic || 0,
        health: data?.md_room?.new_pending_procedures?.health || 0,
      },
    },
  };
};

const responseSchema = yup.object({
  providerRoom: yup.object({
    requestsFromMd: yup.number().required(),
  }),
  mdRoom: yup.object({
    requestsReturnedByProvider: yup.number().required(),
    newPendingProcedures: yup.object({
      cosmetic: yup.number().required(),
      health: yup.number().required(),
    }),
  }),
});

const ROOMS_NOTIFICATIONS_STALE_TIME_MS = 60 * 1000;

export function useRoomsNotificationsQuery() {
  return useQuery({
    // Logout navigates instead of reloading, so the cache outlives the session.
    // The user id keeps a new login from reading the previous user's counts
    // while they are still fresh. Invalidating by [roomsNotifications] alone
    // still matches, since key matching is prefix based.
    queryKey: [QUERY_KEYS.roomsNotifications, getUserId()],
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    // Counts change from other users' actions too, so they are refreshed on
    // focus/mount within this window. Actions taken by the current user
    // invalidate [QUERY_KEYS.roomsNotifications] to update the badges at once.
    staleTime: ROOMS_NOTIFICATIONS_STALE_TIME_MS,
    cacheTime: ROOMS_NOTIFICATIONS_STALE_TIME_MS + 60 * 1000,
    queryFn: async () => {
      const res = await http.get(HTTP_ENDPOINTS.getRoomsNotifications());

      return responseSchema.validateSync(componseResponse(res), {
        strict: true,
      });
    },
  });
}

export const withRoomsNotificationsQuery = (Component) => {
  return function Wrapper(props) {
    const roomsNotifications = useRoomsNotificationsQuery();
    return <Component {...props} roomsNotifications={roomsNotifications} />;
  };
};
